import '../../scss/article-style.scss'

import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import parse, { attributesToProps, domToReact } from 'html-react-parser'
import { VStack, Heading, Box, Text } from '@chakra-ui/react'

interface Props {
  content: string
  key_takeaway?: string
}

const ArticleContent = ({ content, key_takeaway }: Props) => {
  const { t } = useTranslation()
  const isSSR = typeof window === 'undefined'
  const options = useMemo(() => {
    return {
      replace: (domNode) => {
        if (domNode.name === 'a') {
          return (
            <Text
              as="a"
              textStyle={'bodyPrimary'}
              color={'rgba(5, 119, 218, 1)'}
              fontWeight="600"
              {...attributesToProps(domNode.attribs)}
            >
              {domToReact(domNode.children, options)}
            </Text>
          )
        }
        if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(domNode.name)) {
          return (
            <Heading variant={domNode.name} mb={8}>
              {domToReact(domNode.children, options)}
            </Heading>
          )
        }
        if (['span', 'p'].includes(domNode.name)) {
          return (
            <Text textStyle={'bodyPrimary'} mb={16} color={'#0B1426'}>
              {domToReact(domNode.children, options)}
            </Text>
          )
        }
      },
    }
  }, [])

  const articleContent = useMemo(
    () => parse((content ?? '').replaceAll('\n', ''), options),
    [content, options]
  )

  return (
    <VStack spacing={[13, null, 16, null]} alignItems="flex-start">
      <Box id="article-content" className="article-box-text">
        {articleContent}
      </Box>
      {key_takeaway && (
        <Box
          minW={'100%'}
          p={[12, null, 20, null]}
          bg={'white'}
          boxShadow={'0px 8px 24px rgba(0, 0, 0, 0.05)'}
          borderRadius={'12px'}
        >
          <Heading variant={'h2'}>{t('article.keyTakeaway')}</Heading>
          <Text mt={8} textStyle={'bodyPrimary'} color={'#0B1426'}>
            {key_takeaway}
          </Text>
        </Box>
      )}
    </VStack>
  )
}

export default ArticleContent
